// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__35Cnw","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1ioMJ"};